export function incBaseIdentity(path) {
  const prefix = '/account';
  const startsWithSlash = path.slice(0, 1) === '/';

  if (startsWithSlash || path === '') {
    return "".concat(prefix).concat(path);
  } else {
    return "".concat(prefix, "/").concat(path);
  }
}